import {
  Typography as DSTypography,
  TypographySize,
  TypographyWeight,
} from "@beydesign/storybook"
import { Box, SxProps, Theme } from "@mui/material"
import React from "react"
import { BillingInterval } from "../types/StripeProduct"

interface PricingIntervalSwitchProps {
  selectedInterval: BillingInterval
  onIntervalChange: (interval: BillingInterval) => void
  sx?: SxProps<Theme>
}

export function PricingIntervalSwitch({
  selectedInterval,
  onIntervalChange,
  sx,
}: PricingIntervalSwitchProps) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", ...sx }}>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "var(--colors-light-background-bg-white)",
          borderRadius: "8px",
          padding: "4px",
          width: "fit-content",
          border: "1px solid var(--colors-light-border-border-component)",
        }}
      >
        <Box
          onClick={() => onIntervalChange(BillingInterval.MONTH)}
          sx={{
            padding: "8px 24px",
            borderRadius: "6px",
            cursor: "pointer",
            backgroundColor:
              selectedInterval === BillingInterval.MONTH
                ? "var(--colors-light-background-bg-card-highlight-hover)"
                : "transparent",
            boxShadow:
              selectedInterval === BillingInterval.MONTH
                ? "0 1px 3px rgba(0,0,0,0.1)"
                : "none",
            transition: "all 0.2s ease",
            minWidth: "80px",
            textAlign: "center",
          }}
        >
          <DSTypography
            text="Monthly"
            size={TypographySize.TextM}
            weight={TypographyWeight.SemiBold}
            color={
              selectedInterval === BillingInterval.MONTH
                ? "var(--colors-light-text-text-clicable)"
                : "var(--colors-light-text-text-title)"
            }
          />
        </Box>
        <Box
          onClick={() => onIntervalChange(BillingInterval.YEAR)}
          sx={{
            padding: "8px 24px",
            borderRadius: "6px",
            cursor: "pointer",
            backgroundColor:
              selectedInterval === BillingInterval.YEAR
                ? "var(--colors-light-background-bg-card-highlight-hover)"
                : "transparent",
            boxShadow:
              selectedInterval === BillingInterval.YEAR
                ? "0 1px 3px rgba(0,0,0,0.1)"
                : "none",
            transition: "all 0.2s ease",
            minWidth: "80px",
            textAlign: "center",
          }}
        >
          <DSTypography
            text="Yearly"
            size={TypographySize.TextM}
            weight={TypographyWeight.SemiBold}
            color={
              selectedInterval === BillingInterval.YEAR
                ? "var(--colors-light-text-text-clicable)"
                : "var(--colors-light-text-text-title)"
            }
          />
        </Box>
      </Box>
    </Box>
  )
}
